"use strict";
/**
 * @fileoverview gRPC-Web generated client stub for loopup.ctgateway.v2
 * @enhanceable
 * @public
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingAPIClient = void 0;
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck
var grpcWeb = require("grpc-web");
var v2_billing_api_pb = require("../v2/billing_api_pb");
var BillingAPIClient = /** @class */ (function () {
    function BillingAPIClient(hostname, credentials, options) {
        this.methodInfoGetBillingHierarchy = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.BillingAPI/GetBillingHierarchy', grpcWeb.MethodType.UNARY, v2_billing_api_pb.GetBillingHierarchyRequest, v2_billing_api_pb.GetBillingHierarchyResponse, function (request) {
            return request.serializeBinary();
        }, v2_billing_api_pb.GetBillingHierarchyResponse.deserializeBinary);
        this.methodInfoGetOneOffCharges = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.BillingAPI/GetOneOffCharges', grpcWeb.MethodType.UNARY, v2_billing_api_pb.GetOneOffChargesRequest, v2_billing_api_pb.GetOneOffChargesResponse, function (request) {
            return request.serializeBinary();
        }, v2_billing_api_pb.GetOneOffChargesResponse.deserializeBinary);
        this.methodInfoGetCredits = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.BillingAPI/GetCredits', grpcWeb.MethodType.UNARY, v2_billing_api_pb.GetCreditsRequest, v2_billing_api_pb.GetCreditsResponse, function (request) {
            return request.serializeBinary();
        }, v2_billing_api_pb.GetCreditsResponse.deserializeBinary);
        this.methodInfoGetAdvancedPayments = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.BillingAPI/GetAdvancedPayments', grpcWeb.MethodType.UNARY, v2_billing_api_pb.GetAdvancedPaymentsRequest, v2_billing_api_pb.GetAdvancedPaymentsResponse, function (request) {
            return request.serializeBinary();
        }, v2_billing_api_pb.GetAdvancedPaymentsResponse.deserializeBinary);
        this.methodInfoGetProducts = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.BillingAPI/GetProducts', grpcWeb.MethodType.UNARY, v2_billing_api_pb.GetProductsRequest, v2_billing_api_pb.GetProductsResponse, function (request) {
            return request.serializeBinary();
        }, v2_billing_api_pb.GetProductsResponse.deserializeBinary);
        this.methodInfoGetChargeGroups = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.BillingAPI/GetChargeGroups', grpcWeb.MethodType.UNARY, v2_billing_api_pb.GetChargeGroupsRequest, v2_billing_api_pb.GetChargeGroupsResponse, function (request) {
            return request.serializeBinary();
        }, v2_billing_api_pb.GetChargeGroupsResponse.deserializeBinary);
        this.methodInfoGetCommitmentsForGroup = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.BillingAPI/GetCommitmentsForGroup', grpcWeb.MethodType.UNARY, v2_billing_api_pb.GetCommitmentsForGroupRequest, v2_billing_api_pb.GetCommitmentsForGroupResponse, function (request) {
            return request.serializeBinary();
        }, v2_billing_api_pb.GetCommitmentsForGroupResponse.deserializeBinary);
        this.methodInfoGetActiveBillingPeriods = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.BillingAPI/GetActiveBillingPeriods', grpcWeb.MethodType.UNARY, v2_billing_api_pb.GetActiveBillingPeriodsRequest, v2_billing_api_pb.GetActiveBillingPeriodsResponse, function (request) {
            return request.serializeBinary();
        }, v2_billing_api_pb.GetActiveBillingPeriodsResponse.deserializeBinary);
        this.methodInfoAddAdvancedPayment = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.BillingAPI/AddAdvancedPayment', grpcWeb.MethodType.UNARY, v2_billing_api_pb.AddAdvancedPaymentRequest, v2_billing_api_pb.AddAdvancedPaymentResponse, function (request) {
            return request.serializeBinary();
        }, v2_billing_api_pb.AddAdvancedPaymentResponse.deserializeBinary);
        this.methodInfoAddOneOffCharge = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.BillingAPI/AddOneOffCharge', grpcWeb.MethodType.UNARY, v2_billing_api_pb.AddOneOffChargeRequest, v2_billing_api_pb.AddOneOffChargeResponse, function (request) {
            return request.serializeBinary();
        }, v2_billing_api_pb.AddOneOffChargeResponse.deserializeBinary);
        this.methodInfoAddCredit = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.BillingAPI/AddCredit', grpcWeb.MethodType.UNARY, v2_billing_api_pb.AddCreditRequest, v2_billing_api_pb.AddCreditResponse, function (request) {
            return request.serializeBinary();
        }, v2_billing_api_pb.AddCreditResponse.deserializeBinary);
        this.methodInfoAddGroupCommitment = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.BillingAPI/AddGroupCommitment', grpcWeb.MethodType.UNARY, v2_billing_api_pb.AddGroupCommitmentRequest, v2_billing_api_pb.AddGroupCommitmentResponse, function (request) {
            return request.serializeBinary();
        }, v2_billing_api_pb.AddGroupCommitmentResponse.deserializeBinary);
        this.methodInfoMakeGroupABillingEntity = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.BillingAPI/MakeGroupABillingEntity', grpcWeb.MethodType.UNARY, v2_billing_api_pb.MakeGroupABillingEntityRequest, v2_billing_api_pb.MakeGroupABillingEntityResponse, function (request) {
            return request.serializeBinary();
        }, v2_billing_api_pb.MakeGroupABillingEntityResponse.deserializeBinary);
        this.methodInfoUpdateBillingEntity = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.BillingAPI/UpdateBillingEntity', grpcWeb.MethodType.UNARY, v2_billing_api_pb.UpdateBillingEntityRequest, v2_billing_api_pb.UpdateBillingEntityResponse, function (request) {
            return request.serializeBinary();
        }, v2_billing_api_pb.UpdateBillingEntityResponse.deserializeBinary);
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname;
        this.credentials_ = credentials;
        this.options_ = options;
    }
    BillingAPIClient.prototype.getBillingHierarchy = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.BillingAPI/GetBillingHierarchy', request, metadata || {}, this.methodInfoGetBillingHierarchy, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.BillingAPI/GetBillingHierarchy', request, metadata || {}, this.methodInfoGetBillingHierarchy);
    };
    BillingAPIClient.prototype.getOneOffCharges = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.BillingAPI/GetOneOffCharges', request, metadata || {}, this.methodInfoGetOneOffCharges, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.BillingAPI/GetOneOffCharges', request, metadata || {}, this.methodInfoGetOneOffCharges);
    };
    BillingAPIClient.prototype.getCredits = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.BillingAPI/GetCredits', request, metadata || {}, this.methodInfoGetCredits, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.BillingAPI/GetCredits', request, metadata || {}, this.methodInfoGetCredits);
    };
    BillingAPIClient.prototype.getAdvancedPayments = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.BillingAPI/GetAdvancedPayments', request, metadata || {}, this.methodInfoGetAdvancedPayments, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.BillingAPI/GetAdvancedPayments', request, metadata || {}, this.methodInfoGetAdvancedPayments);
    };
    BillingAPIClient.prototype.getProducts = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.BillingAPI/GetProducts', request, metadata || {}, this.methodInfoGetProducts, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.BillingAPI/GetProducts', request, metadata || {}, this.methodInfoGetProducts);
    };
    BillingAPIClient.prototype.getChargeGroups = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.BillingAPI/GetChargeGroups', request, metadata || {}, this.methodInfoGetChargeGroups, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.BillingAPI/GetChargeGroups', request, metadata || {}, this.methodInfoGetChargeGroups);
    };
    BillingAPIClient.prototype.getCommitmentsForGroup = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.BillingAPI/GetCommitmentsForGroup', request, metadata || {}, this.methodInfoGetCommitmentsForGroup, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.BillingAPI/GetCommitmentsForGroup', request, metadata || {}, this.methodInfoGetCommitmentsForGroup);
    };
    BillingAPIClient.prototype.getActiveBillingPeriods = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.BillingAPI/GetActiveBillingPeriods', request, metadata || {}, this.methodInfoGetActiveBillingPeriods, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.BillingAPI/GetActiveBillingPeriods', request, metadata || {}, this.methodInfoGetActiveBillingPeriods);
    };
    BillingAPIClient.prototype.addAdvancedPayment = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.BillingAPI/AddAdvancedPayment', request, metadata || {}, this.methodInfoAddAdvancedPayment, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.BillingAPI/AddAdvancedPayment', request, metadata || {}, this.methodInfoAddAdvancedPayment);
    };
    BillingAPIClient.prototype.addOneOffCharge = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.BillingAPI/AddOneOffCharge', request, metadata || {}, this.methodInfoAddOneOffCharge, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.BillingAPI/AddOneOffCharge', request, metadata || {}, this.methodInfoAddOneOffCharge);
    };
    BillingAPIClient.prototype.addCredit = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.BillingAPI/AddCredit', request, metadata || {}, this.methodInfoAddCredit, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.BillingAPI/AddCredit', request, metadata || {}, this.methodInfoAddCredit);
    };
    BillingAPIClient.prototype.addGroupCommitment = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.BillingAPI/AddGroupCommitment', request, metadata || {}, this.methodInfoAddGroupCommitment, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.BillingAPI/AddGroupCommitment', request, metadata || {}, this.methodInfoAddGroupCommitment);
    };
    BillingAPIClient.prototype.makeGroupABillingEntity = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.BillingAPI/MakeGroupABillingEntity', request, metadata || {}, this.methodInfoMakeGroupABillingEntity, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.BillingAPI/MakeGroupABillingEntity', request, metadata || {}, this.methodInfoMakeGroupABillingEntity);
    };
    BillingAPIClient.prototype.updateBillingEntity = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/loopup.ctgateway.v2.BillingAPI/UpdateBillingEntity', request, metadata || {}, this.methodInfoUpdateBillingEntity, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/loopup.ctgateway.v2.BillingAPI/UpdateBillingEntity', request, metadata || {}, this.methodInfoUpdateBillingEntity);
    };
    return BillingAPIClient;
}());
exports.BillingAPIClient = BillingAPIClient;
